<template lang="pug">
modal#warning-save-and-close-bulk-send-modal(
  :no-footer='true'
  :title='$t("modal.warningSaveAndCloseEnvelope.title")'
  ref='modal'
  size='sm'
)
  .text-start {{ $t('configureBulkSend.confirmDiscard') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/warning-envelope.svg')
  .text-end.mt-5
    button.btn.btn-secondary.me-2(
      @click='saveAndClose'
      data-bs-dismiss='modal'
      type='button'
    )
      span.text {{ $t('modal.warningSaveAndCloseEnvelope.saveAndCloseButton') }}
    button.btn.btn-danger(
      @click='discardChanges'
      data-bs-dismiss='modal'
      type='button'
    )
      span.text {{ $t('modal.warningSaveAndCloseEnvelope.discardButton') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'WarningSaveAndCloseBulkSendModal',
  components: {
    Modal,
  },
  methods: {
    saveAndClose() {
      this.$emit('saveAndClose');
    },
    discardChanges() {
      this.$emit('discardChanges');
    },
  },
};
</script>
